import React from 'react';
import OverflowTooltip from '../utils/OverflowTooltip';
import ArrowIconToggle from '../utils/icon/ArrowIconToggle';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

// XXX reconcile with SortableTableHeader
export default class DoublySortableTableHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const {onClick, renderColumn, renderColumn2, sortColumn} = this.props;
    if (!this.isSortedColumn()) {
      onClick(renderColumn);
    }
    // the sequence of clicks is
    // column1 defaultDirection -> column2 defaultDirection -> column1 theOtherDirection -> column2 theOtherDirection
    if (sortColumn === renderColumn) {
      const changeDirection = false;
      onClick(renderColumn2, changeDirection);
    } else if (sortColumn === renderColumn2) {
      const changeDirection = true;
      onClick(renderColumn, changeDirection);
    }
  }

  isSortedColumn() {
    const {renderColumn, renderColumn2, sortColumn} = this.props;
    return sortColumn === renderColumn || sortColumn === renderColumn2;
  }

  getSortIndicator(sortDirection) {
    if (!this.isSortedColumn()) {
      return null;
    }
    return sortDirection;
  }

  render() {
    const {
      key,
      label,
      labelSorted,
      label2Sorted,
      sortDirection,
      renderColumn,
      sortColumn,
      tooltipEnabled = true,
      popoverMessage,
      popoverClassName,
      sortingDisabled = false,
    } = this.props;

    const labelElement = (
      <div className="header-text-overflow">
        {!this.isSortedColumn() ? label : sortColumn === renderColumn ? labelSorted : label2Sorted}
      </div>
    );
    return (
      <GenericTooltip
        positionTop
        delay={TOOLTIP_DELAY}
        tooltip={popoverMessage}
        className={popoverClassName}>
        <div
          className={`header-wrapper ${sortingDisabled ? 'no-sort' : ''}`}
          onClick={e => !sortingDisabled && this.onClick(e)}>
          <div className="header-text">
            {tooltipEnabled ? (
              <OverflowTooltip tooltipText={label} divKey={'item-' + key ? key : label}>
                {labelElement}
              </OverflowTooltip>
            ) : (
              labelElement
            )}
          </div>
          <ArrowIconToggle sortDirection={this.getSortIndicator(sortDirection)} />
        </div>
      </GenericTooltip>
    );
  }
}
